export default __webpack_public_path__ + "static/media/lefteye.7b5d3839.svg";